<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">科目余额表</span>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-range-choose v-model="dateRange"/>
			<Button color="primary" icon="fa fa-search" :loading="loading" @click="loadList" class="margin-left">查询</Button>
			<div class="float-right">
				<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
			</div>
		</div>
		<div class="h-panel-body">
			<table class="balance" v-if="!showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2">科目编码</td>
					<td rowspan="2">科目名称</td>
					<td colspan="2">期初余额</td>
					<td colspan="2">本期发生额</td>
					<td colspan="2">本年累计发生额</td>
					<td colspan="2">期末余额</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjectId">
					<td :style="{'padding-left':(item.level)*10+'px'}">
						<span class="code-link text-hover blue-color" @click="goToDetail(item)">{{item.code}}</span>
					</td>
					<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
					<td align="right">{{item.beginningDebitBalance|numFormat}}</td>
					<td align="right">{{item.beginningCreditBalance|numFormat}}</td>
					<td align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td align="right">{{item.currentCreditAmount|numFormat}}</td>
					<td align="right">{{item.yearDebitAmount|numFormat}}</td>
					<td align="right">{{item.yearCreditAmount|numFormat}}</td>
					<td :class="{tip:item.endingDebitBalance<0}" align="right">{{item.endingDebitBalance|numFormat}}</td>
					<td :class="{tip:item.endingCreditBalance<0}" align="right">{{item.endingCreditBalance|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="10" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
			<table class="balance" v-else>
				<thead class="header">
				<tr>
					<td rowspan="2">科目编码</td>
					<td rowspan="2">科目名称</td>
					<td colspan="4">期初余额</td>
					<td colspan="4">本期发生额</td>
					<td colspan="4">期末余额</td>
				</tr>
				<tr>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
					<td>借方数量</td>
					<td>借方金额</td>
					<td>贷方数量</td>
					<td>贷方金额</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjectId">
					<td :style="{'padding-left':(item.level)*10+'px'}">
						<span class="code-link text-hover blue-color" @click="goToDetail(item)">{{item.code}}</span>
					</td>
					<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
					<td class="text-right">&nbsp;</td>
					<td class="text-right" align="right">{{item.beginningDebitBalance|numFormat}}</td>
					<td class="text-right">&nbsp;</td>
					<td class="text-right" align="right">{{item.beginningCreditAmount|numFormat}}</td>

					<td class="text-right" align="right">{{item.currentDebitAmountNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentCreditAmountNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.currentCreditAmount|numFormat}}</td>

					<td class="text-right" align="right">{{item.endingDebitBalanceNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingDebitBalance|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingCreditBalanceNum|numFormat}}</td>
					<td class="text-right" align="right">{{item.endingCreditBalance|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="14" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
	import AccountDateRangeChoose from '@/components/AccountDateRangeChoose.vue';

	export default {
		name: "SubjectBalance",
		components: {AccountDateRangeChoose},
		data() {
			return {
				dataList: [],
				dateRange: null,
				showNumPrice: false,
				loading: false
			}
		},
		watch: {
			dateRange: {
				handler(val) {
					if (val && val.startDate && val.endDate) {
						this.loadList();
					}
				},
				deep: true
			},
			showNumPrice() {
				this.loadList();
			}
		},
		methods: {
			loadList() {
				if (!this.dateRange) return;
				this.loading = true;
				this.$api.accountbook.loadSubjectBalance({
					startYear: this.dateRange.startYear,
					startMonth: this.dateRange.startMonth,
					endYear: this.dateRange.endYear,
					endMonth: this.dateRange.endMonth,
					showNumPrice: this.showNumPrice
				}).then(({data}) => {
					this.dataList = data;
				}).finally(() => {
					this.loading = false;
				});
			},
			goToDetail(item) {
				// 跳转到明细账页面，带上科目参数
				this.$router.push({
					name: 'DetailedAccounts',
					query: {
						subjectId: item.subjectId,
						subjectCode: item.code,
						startYear: this.dateRange.startYear,
						startMonth: this.dateRange.startMonth,
						endYear: this.dateRange.endYear,
						endMonth: this.dateRange.endMonth
					}
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.balance {
		width: 100%;
		border-collapse: collapse;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		border-radius: 4px;
		overflow: hidden;

		td {
			padding: 8px 10px;
			border: 1px solid #e8e8e8;
			font-size: 12px;
			height: 36px;

			&.tip {
				background-color: #FFF1F0;
				color: #f5222d;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #fafafa;
		}

		tbody tr:hover {
			background-color: #e6f7ff;
		}

		.header {
			td {
				background: linear-gradient(to bottom, #fafafa, #f0f0f0);
				text-align: center;
				font-weight: 600;
				height: 38px;
				color: #333;
				border-bottom: 2px solid #d9d9d9;
			}
		}

		.code-link {
			cursor: pointer;
			text-decoration: underline;
			color: #1890ff;
			
			&:hover {
				color: #40a9ff;
			}
		}
	}
</style>
